import { Component, OnInit, ElementRef, ViewChild, Input, OnDestroy } from '@angular/core';
import { SearchService } from '../../_service/search/search.service';
import { SearchHistoryService } from '../../_service/search/search-history.service';
//import { SearchInstanceResultService } from '../../_service/search/search-instance-result.service';
import { timer, Subject, Subscription } from 'rxjs';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ToastService } from '../../_service/toast/toast.service';

import { debounceTime } from 'rxjs/operators';
@Component({
  selector: 'app-dn-search-input',
  templateUrl: './dn-search-input.component.html',
  styleUrls: ['./dn-search-input.component.scss']
})

export class DnSearchInputComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  keyword = '';
  keyword$ = new Subject<string>();
  placeholder = '搜电影';
  focused = false;
  trendingSearch: Array<any> = [];
  searchHistory: Array<any> = [];
  searchSuggest: Array<any>;
  instanceResult: Array<any> = [];
  searchSuggestIndex = 0;
  searchHistoryCount = 0;
  // @Input()
  // screenSize;
  searchType = '';

  // screenType = ScreenSize;
  @ViewChild('searchInput', { static: true }) inputEl: ElementRef;

  constructor(
    private _searchService: SearchService,
    private _searchHistoryService: SearchHistoryService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _toastService: ToastService,
  ) {

  }

  ngOnInit() {
    this.subscriptions.push(
      this.keyword$
        .pipe(
          debounceTime(200)
        )
        .subscribe(() => {
          this.getInstanceResultList(this.keyword, true);
        })
    );

    this.subscriptions.push(
      this._router.events.subscribe(e => {
        if (e instanceof NavigationEnd) {
          this.keyword = this._activatedRoute.snapshot.queryParams['keyword'] ? this._activatedRoute.snapshot.queryParams['keyword'] : '';
          this.instanceResult = []
          this.searchType = this._activatedRoute.snapshot.queryParams['type'] ? this._activatedRoute.snapshot.queryParams['type'] : '';
        }
      })
    );

    this.keyword = this._activatedRoute.snapshot.queryParams['keyword'] ? this._activatedRoute.snapshot.queryParams['keyword'] : '';



    this.getTrendingList();

    this.getHistoryList();

    this.getSuggestList();

    this.showSuggestedSearch();


  }

  getTrendingList() {
    // this.subscriptions.push(
    //   this._searchService.getTrendingSearchList()
    //     .subscribe(items => {
    //       this.trendingSearch = items;
    //     })
    // );
    this._searchService.getTrendingSearchList().subscribe(res => {
      this.trendingSearch = res;

    })
  }

  getHistoryList() {
    this.subscriptions.push(
      this._searchHistoryService.getAll()
        .subscribe(items => {
          this.searchHistory = items;
          this.updateSearchHistoryCount();
        })
    );
  }

  getSuggestList() {
    // this.subscriptions.push(
    // this._searchService.getTrendingSearchList().subscribe(items=>{
    //   this.searchSuggest = items;
    //  // console.log(items)
    // }));
    this.subscriptions.push(
      this._searchService.getSearchSuggestList()
        .subscribe(items => {
          this.searchSuggest = items;
        })
    );
  }

  getInstanceResultList(keyword, titleOnly = false) {
    if (keyword.trim() === '') {
      this.instanceResult = [];
      return;
    }
    this.subscriptions.push(
      this._searchService.solrSearch({ keyword: keyword, istitle: titleOnly }).subscribe(res => {
        this.instanceResult = res.items;
      }));
  }

  showSuggestedSearch() {
    this.subscriptions.push(
      timer(0, 5000).subscribe(() => {
        if (this.searchSuggest) {
          this.placeholder = this.searchSuggest[this.searchSuggestIndex].title;
          this.searchSuggestIndex++;
          if (this.searchSuggestIndex === this.searchSuggest.length) {
            this.searchSuggestIndex = 0;
          }
        }
      })
    );
  }

  //loaded = false;
  onFocus(event) {
    this.focused = true;
    event.target.select();
  }

  focusOut() {
    this.keyword = this.keyword.trim();
    setTimeout(() => { this.focused = false; }, 200);
  }
  private selectNextItem(next = 1) {
    if (this.instanceResult.length > 0) {
      let index = this.instanceResult.findIndex(p => p.isActive);
      if (index == -1) {
        this.instanceResult[0].isActive = true;
      }
      else {
        if (!(index + next == this.instanceResult.length) && (index + next >= 0)) {
          this.instanceResult[index].isActive = false;
          index += next;
          this.instanceResult[index].isActive = true;

        }
      }
    }
  }
  onKeydown(event) {
    switch (event.key) {
      case "ArrowDown":
        this.selectNextItem(1);
        event.preventDefault();
        return false;
        break;
      case "ArrowUp":
        this.selectNextItem(-1);
        event.preventDefault();
        return false;
        break;
    }

  }
  onKeyup(event) {
    //console.log(event.key)
    switch (event.key) {
      case "Enter":
        var index = this.instanceResult.findIndex(p => p.isActive);
        if (index > -1) {
          this.keyword = this.instanceResult[index].title;
        }
        this.instanceResult = [];
        this.search();
        break;
      case "ArrowDown":
      case "ArrowUp":
        break;

      default:
        this.keyword$.next(event.target.value);
    }
    // if (event.key === 'Enter') {
    //   this.instanceResult = [];
    //   this.search();
    // } else {
    //   this.keyword$.next(event.target.value);
    // }
  }

  clearSearchHistory() {
    this.searchHistory = this._searchHistoryService.clear();
    this.updateSearchHistoryCount();
    this._toastService.showBlackToast('已清空！');
  }

  updateSearchHistoryCount() {
    this.searchHistoryCount = this.searchHistory.length;
  }

  selectSearch(keyword) {
    this.keyword = keyword;
    this.search();
  }

  search() {
    if (this.focused && this.keyword.trim() === '') {
      return;
    }

    try {
      if (this.keyword.trim() === '') {
        if (this.searchSuggest.length) {
          this.keyword = this.searchSuggest[this.searchSuggestIndex - 1].title;
        }
      }
    }
    catch (err) {
      return;
    }

    this.searchHistory = this._searchHistoryService.push(this.keyword);
    this.updateSearchHistoryCount();

    // const baseUrl = this._router.url.split('?')[0].split('/').filter(p=>p.[0];
    // this._router.navigate(['/search',this.keyword]);

    // if (baseUrl === 'search') {
    //   console.log("******");
    // }
    this._router.navigate(['/search', this.keyword.trim()], this.searchType ? { queryParams: { type: this.searchType } } : {});
    //  else {
    //   window.open('/search?keyword=' + this.keyword);
    // }
  }

  onSuggestClick() {
    this.inputEl.nativeElement.focus();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

}
